// extracted by mini-css-extract-plugin
export default {"small-btn":"SmallButton_small-btn__+hxao"};